import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/** 이 거리 이내(px)에선 항상 표시. 최상단 부근 떨림 방지용. */
const DEFAULT_REVEAL_THRESHOLD = 80;
/** 숨김/표시를 토글하기 위한 프레임 간 최소 스크롤 변화량(px). 미세 움직임 필터. */
const DIRECTION_DELTA = 4;
interface UseHideOnScrollOptions {
  /** false면 리스너를 등록하지 않음. 항상 표시 상태 유지. */
  enabled?: boolean;
  /** 이 거리 이내에선 항상 표시. */
  revealThreshold?: number;
}

/**
 * 스크롤 방향/위치에 따라 헤더 상태를 반환.
 * - `hidden`: 아래로 스크롤 & revealThreshold 이상일 때 true / 위로 스크롤 또는 threshold 이내는 false
 * - `atTop`: 현재 스크롤이 revealThreshold 이내이면 true
 */
export function useHideOnScroll(t0) {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2,
    revealThreshold: t3
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  const revealThreshold = t3 === undefined ? DEFAULT_REVEAL_THRESHOLD : t3;
  const [hidden, setHidden] = useState(false);
  const [atTop, setAtTop] = useState(true);
  let t4;
  let t5;
  if ($[2] !== enabled || $[3] !== revealThreshold) {
    t4 = () => {
      if (!enabled) {
        return;
      }
      let lastY = window.scrollY;
      let ticking = false;
      const update = () => {
        const currentY = window.scrollY;
        const delta = currentY - lastY;
        const nextAtTop = currentY < revealThreshold;
        setAtTop(nextAtTop);
        if (nextAtTop) {
          setHidden(false);
        } else {
          if (delta > DIRECTION_DELTA) {
            setHidden(true);
          } else {
            if (delta < -DIRECTION_DELTA) {
              setHidden(false);
            }
          }
        }
        lastY = currentY;
        ticking = false;
      };
      const onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      };
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", onScroll);
    };
    t5 = [enabled, revealThreshold];
    $[2] = enabled;
    $[3] = revealThreshold;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== atTop || $[7] !== hidden) {
    t6 = {
      hidden,
      atTop
    };
    $[6] = atTop;
    $[7] = hidden;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}